import React from "react";
import styles from "./TextInput.module.css";
import { useField, useFormikContext } from "formik";
import { FormField, TextInput as MiloInput } from "@justworkshr/milo-form";
interface ITextInputProps {
  name: string;
  label: string;
  message?: string;
  placeholder?: string;
  type?: string;
  required?: boolean;
  className?: string;
  disabled?: boolean;
  fieldRefs?: React.MutableRefObject<{
    [key: string]: HTMLInputElement | null;
  }>;
}

const TextInput = ({ ...props }: ITextInputProps): JSX.Element => {
  const {
    name,
    label,
    placeholder,
    type,
    message,
    required = true,
    className,
    disabled,
    fieldRefs,
  } = props;
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  return (
    <div className={`${styles.container} ${className}`}>
      <FormField
        required={required}
        message={message}
        label={label}
        error={meta.touched ? meta.error : ""}
      >
        <MiloInput
          className={styles.textInput}
          data-testid={name}
          id={name}
          placeholder={placeholder}
          type={type}
          disabled={disabled}
          ref={(el) => {
            if (fieldRefs?.current) {
              fieldRefs.current[name] = el as HTMLInputElement | null;
            }
          }}
          {...field}
          onBlur={(e) => {
            field.onBlur(e); // Call formik onBlur to trigger validations
            setFieldValue(name, e.target.value.trim());
          }}
        />
      </FormField>
    </div>
  );
};

export default TextInput;
